












































import Vue from 'vue';
import { testFunctionDialog } from './TestFunction';
import { getRunProgram, PREF_FULLSCREEN_RUN_PROGRAM } from './RunProgram';
import { Preferences } from './Preference';
import { Program } from 'expangine-runtime';


export default Vue.extend({
  data: () => testFunctionDialog,
  computed: {
    isFullscreen(): boolean {
      return this.$vuetify.breakpoint.mdAndDown || this.fullscreen;
    },
    isFullscreenToggleVisible(): boolean {
      return !this.$vuetify.breakpoint.mdAndDown;
    },
  },
  methods: {
    toggleFullscreen() {
      this.fullscreen = !this.fullscreen;

      Preferences.set(PREF_FULLSCREEN_RUN_PROGRAM, this.fullscreen);
    },
    test() {
      getRunProgram({
        registry: this.registry,
        program: Program.create(this.registry.defs, {
          dataType: this.params,
          datasets: [{ 
            name: '',
            data: this.data,
            created: 0,
            updated: 0,
            meta: null,
          }],
          expression: this.func.expression,
        }),
      });
    },
  },
});
